import chunkArray from 'helpers/chunkArray';
import { ReactNode } from 'react';
import cn from 'classnames';
import StnVideoAd from './ads/StnVideoAd';
import MinuteMediaAd from './ads/MinuteMediaAd';
import styles from './styles/InfiniteBlockLayout.module.scss';
export default function InfiniteBlockLayout({
  children,
  blockSize,
  className,
  disabled,
  videoIndex
}: {
  blockSize: number;
  children: ReactNode[];
  className?: string;
  disabled?: boolean;
  videoIndex?: number;
}) {
  return (
    <>
      {videoIndex && (
        <>
          <div className={className}>{children.slice(0, videoIndex)}</div>
          <StnVideoAd placement="INLINE" className={styles.VideoAd} />
        </>
      )}
      {disabled ? (
        <div className={className}>{children.slice(videoIndex)}</div>
      ) : (
        // <div className="content-block"> // this class triggers an additional ad being inserted, follow-up with MM
        <div>
          {chunkArray(children.slice(videoIndex), blockSize).map((child, index) => {
            return (
              <div key={index} className={cn(className, 'group-of-elements')}>
                {child}
                <MinuteMediaAd placement={`IN_FEED`} className={styles.InfiniteScrollAd} />
              </div>
            );
          })}
        </div>
      )}
    </>
  );
}
